namespace SP {
    export interface PackageCollectionInfo {
        id: number;
        createdAt: string;
        closedAt: string;
        closed: boolean;
        packageCount: number;
        warehouseZone: string;
        sortingZoneId: string;
        sortingZoneName: string;
        waybillId: number;
        waybillNo: string;
        routingLabelNo: string;
        printed: boolean;
    }


    export interface WaybillInfo {
        id: number;
        created: string;
        waybillAPI: string;
        waybillData: string;
        waybillNo: string;
        sender: Address;
        recipient: Address;
        packageCollections: PackageCollectionInfo[];
    }
}